import { Component, ElementRef, OnDestroy, OnInit, signal, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BsModalService, BsModalRef, ModalModule } from 'ngx-bootstrap/modal';
// import { BaseChartDirective } from 'ng2-charts';
import { id, NgxChartsModule } from '@swimlane/ngx-charts';
import { NgSelectModule } from '@ng-select/ng-select';
import { MenuComponent } from '../../shared/menu/menu.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ApiService } from '../../Core/services/api.service';
import { LoaderComponent } from '../../shared/loader/loader.component';
import { startWith } from 'rxjs';
import { ToastService } from '../../Core/services/toast.service';
import { error } from 'console';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { OtpComponent } from '../../shared/Modals/otp/otp.component';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../Core/services/authentication.service';
import { NoResultComponent } from '../../shared/no-result/no-result.component';


@Component({
  selector: 'app-expense',
  imports: [ FormsModule, CommonModule, ReactiveFormsModule, ModalModule, NgxChartsModule, FormsModule, NgSelectModule, MenuComponent, NgScrollbarModule, LoaderComponent, NgbPaginationModule, NoResultComponent],
  templateUrl: './expense.component.html',
  styleUrl: './expense.component.scss'
})
export class ExpenseComponent implements OnInit, OnDestroy {
  modalRef?: BsModalRef;
  allMonthlyexpenses:any = []
  billForm: FormGroup;
  extrasForm: FormGroup;
  searchText: string = '';
  selectedPaymentStatus: string;
  @ViewChild('generateBillModal') generateBillModal!: TemplateRef<any>;
  months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  years = [2021,2022,2023,2024,2025]
  periods = [
    { value: 1, label: '1 month' },
    { value: 2, label: '2 months' },
    { value: 3, label: '3 months' },
    { value: 4, label: '4 months' },
    { value: 5, label: '5 months' },
    { value: 6, label: '6 months' },
    { value: 7, label: '7 months' },
    { value: 8, label: '8 months' },
    { value: 9, label: '9 months' },
    { value: 10, label: '10 months' },
    { value: 11, label: '11 months' },
    { value: 12, label: '12 months' }
  ];
  filterMonths = [
    { value: '01', name: 'January' },
    { value: '02', name: 'February' },
    { value: '03', name: 'March' },
    { value: '04', name: 'April' },
    { value: '05', name: 'May' },
    { value: '06', name: 'June' },
    { value: '07', name: 'July' },
    { value: '08', name: 'August' },
    { value: '09', name: 'September' },
    { value: '10', name: 'October' },
    { value: '11', name: 'November' },
    { value: '12', name: 'December' }
  ];

  categories = ['AWS', 'Salaries', 'Utilities', 'Marketing', 'Extras', 'Rent'];
  types  = [
    { display: 'ONE OFF', value: 'ONE_OFF' },
    { display: 'RECURRING', value: 'RECURRING' }
    // { display: '3 MONTHS', value: 'THREE_MONTH' },
    // { display: '6 MONTHS', value: 'SIX_MONTH' }
  ];expenseData: any;
  currentPage: number = 1;
  pageForm: FormGroup;
  maxsize = 3
  itemsPerPage = 25
  selectedMonths = { 'selectedMonth': [], 'selectedPaidMonth': [], 'selectedCheckIn': [], 'selectedMonthDeadLineDate': [], 'selectedSupplierDueMonth':[] };
  selectedDatesYear = { 'selectedMonth': 2025, 'selectedPaidMonth': 2025, 'selectedCheckIn': 2025, 'selectedMonthDeadLineDate': 2025, 'selectedSupplierDueMonth': 2025 };
  paymentStatuses = [ 'UNPAID', 'PAID'];
  currency = ['AED', 'GBP', 'USD', 'INR', 'EUR', 'CAD', 'AUD', 'JPY', 'CNY'];
  menuCollapsed = signal(false);
  latestDueDate: Date | null = null;
  isDropdownOpen = {};
  selectedMonth:any
  selectedPaidMonth:any

  datepickerConfig = {
    dateInputFormat: 'DD/MM/YYYY',
    containerClass: 'theme-dark-blue',
    showWeekNumbers: false,
    animations: false,  // Ensure animations are enabled
    adaptivePosition: true
  };

  pieData = [
    { name: 'AWS', value: 25 },
    { name: 'Salaries', value: 50 },
    { name: 'Utilities', value: 10 },
    { name: 'Rent', value: 10 },
    { name: 'Marketing', value: 2.5 },
    { name: 'Extras', value: 2.5 }
  ];

  // Bar chart data
  barData = [
    { name: 'Jan', value: 200 },
    { name: 'Feb', value: 450 },
    { name: 'Mar', value: 300 },
    { name: 'Apr', value: 1000 },
    { name: 'May', value: 700 },
    { name: 'Jun', value: 1200 },
    { name: 'Jul', value: 1100 },
    { name: 'Aug', value: 950 },
    { name: 'Sep', value: 1500 },
    { name: 'Oct', value: 1800 },
    { name: 'Nov', value: 2000 },
    { name: 'Dec', value: 2400 }
  ];
  isUploading: boolean;
  base64ImageInclusiveHolidays: string;
  document: any;
  editingExpense: any;
  editExpense: boolean = false;
  loader: boolean = false;
  private searchTimeout: any;
hoverIndex: any;
  isFilterApplied: boolean;
  otpVerified: boolean;

  get expenses() {
    return this.billForm.get('expenses') as FormArray;
  }
  get extras() {
    return this.extrasForm.get('expenses') as FormArray;
  }

  constructor(private fb: FormBuilder, private modalService: BsModalService, private apiService: ApiService, private toastService : ToastService, private router : Router, private authService : AuthenticationService) {
    this.billForm = this.fb.group({
      expenses: this.fb.array([])
    });
    this.extrasForm = this.fb.group({
      expenses: this.fb.array([])
    });
    this.pageForm = this.fb.group({
      currentPageControl: new FormControl(1),
    });
  }

  ngOnInit(): void {
    // this.getExpense();
    this.openOtpModal()
    this.expenses.valueChanges
    .pipe(startWith(this.expenses.value))
    .subscribe(() => {
      // re-apply the rule to every row on any change
      this.enforceRuleOnAllRows();
    });
  }

  private applyExtrasDescriptionRule(row: FormGroup): void {
    const desc = row.get('description');
    const cat  = row.get('category');

    if (!desc || !cat) return;

    const isExtras = (cat.value ?? '').toString().trim().toLowerCase() === 'extras';

    if (isExtras) {
      desc.addValidators(Validators.required);
    } else {
      desc.removeValidators(Validators.required);
    }

    // prevent valueChanges loops
    desc.updateValueAndValidity({ onlySelf: true, emitEvent: false });
  }

  private enforceRuleOnAllRows(): void {
    this.expenses.controls.forEach(ctrl => this.applyExtrasDescriptionRule(ctrl as FormGroup));
  }

  openOtpModal() {
    setTimeout(() => {
      this.otpVerified = sessionStorage.getItem('accessToken') ? true : false;
      if(this.otpVerified) {
        this.getExpense();
      } else {
        this.modalRef = this.modalService.show(OtpComponent, {
          class: 'modal-lg modal-dialog-centered',
          focus: false ,
          backdrop: 'static',
          keyboard: false
        })

        this.modalRef.onHidden?.subscribe(() => {
          this.otpVerified = sessionStorage.getItem('accessToken') ? true : false;
          if(this.otpVerified) {
            this.getExpense();
          this.loader = true;
          } else {
            this.router.navigate(['/crm']);
          }
        });
      }
    }, 1000);
  }

  filterStatus(eve: any) {
    this.selectedPaymentStatus = eve;
    if (eve === 'All' || eve === 'Status') {
      this.selectedPaymentStatus = null;
    }

    this.currentPage = 1;
    this.loader = true;
    this.currentPage = 1;
    this.getExpense();
  }

  onSearchChange() {
    // Clear previous timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    // Set new timeout
    this.searchTimeout = setTimeout(() => {
      this.loader = true;
      this.currentPage = 1;
      this.getExpense();
    }, 1000); // 300ms delay
  }

  removeAllFilters() {
    this.selectedPaymentStatus = '';
    this.selectedMonth = '';
    this.selectedPaidMonth = '';
    this.searchText = '';
    this.currentPage = 1
    // this.applyFilters();
    this.getExpense()
  }

  onPageChange(page: number) {
    this.loader = true;
    this.currentPage = page;
    if (page > this.expenseData.totalPages) {
      this.pageForm.controls['currentPageControl'].setValue(this.expenseData.totalPages);
    }
    this.getExpense();
  }

  toggleDatesDropdown(type:any) {
    const wasOpen = this.isDropdownOpen[type];

    Object.keys(this.isDropdownOpen).forEach(key => {
      this.isDropdownOpen[key] = false;
    });

    this.isDropdownOpen[type] = !wasOpen;
  }

  toggleMonth(monthValue: any,year:any, type:any) {
    if (monthValue === 'All') {
      this.selectedMonths[type] = [] ;
      this.applyMonthSelection(type)
    } else {
      // if (this.selectedMonths[type].includes(year + '-' + monthValue)) {
      if (this.selectedMonths[type].includes(monthValue)) {
        // this.selectedMonths[type] = this.selectedMonths[type].filter(m => m !== monthValue && m !== 'All');
        // let index = this.selectedMonths[type].indexOf(year + '-' + monthValue);
        let index = this.selectedMonths[type].indexOf(monthValue);
        if (index > -1) {
          this.selectedMonths[type].splice(index, 1);
        }
      } else {
        if (this.selectedMonths[type].length < this.months.length) {
          // this.selectedMonths[type].push(year + '-' + monthValue);
          this.selectedMonths[type].push(monthValue);
          // this.selectedMonths[type] = [ ...this.months.map(m => m.value)];
        }
      }
    }
  }

  exportToPDF(data: any[], fileName: string = 'expenses'): void {
    const doc = new jsPDF();

    // Add title
    doc.setFontSize(12);
    doc.text('Expense Report', 14, 22);

    // Prepare table data
    const tableColumn = ['Month', 'Bill ID', 'Bill Name', 'Bill Type', 'Amount', 'Paid', 'Paid Date'];
    const tableRows: any[] = [];

    data.forEach(expense => {
      const expenseData = [
        expense.month || '',
        expense.billId || '',
        expense.billName || '',
        expense.type || '',
        `${expense.amount || 0} ${expense.currency || ''}`,
        expense.paymentStatus || '',
        expense.dueDate ? new Date(expense.dueDate).toLocaleDateString('en-GB') : ''
      ];
      tableRows.push(expenseData);
    });

    // Generate PDF table
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 30,
      theme: 'striped',
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontSize: 10,
        fontStyle: 'bold'
      },
      bodyStyles: {
        fontSize: 10
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      },
      margin: { top: 30, left: 14, right: 14, bottom: 20 },
      didDrawPage: (data) => {
        // Add page numbers
        const pageCount = (doc as any).internal.getNumberOfPages();
        doc.setFontSize(10);
        doc.text(`Page ${data.pageNumber} of ${pageCount}`, data.settings.margin.left, doc.internal.pageSize.height - 10);
      }
    });

    // Save the PDF
    doc.save(`${fileName}.pdf`);
  }

  exportToExcel(data: any[], fileName: string = 'expenses'): void {
    // Prepare data for Excel
    const excelData = data.map(expense => ({
      'Month': expense.month || '',
      'Bill ID': expense.billId || '',
      'Bill Name': expense.billName || '',
      'Bill Type': expense.type || '',
      'Amount': expense.amount || 0,
      'Currency': expense.currency || '',
      'Paid Status': expense.paymentStatus || '',
      'Paid Date': expense?.dueDate ? new Date(expense?.dueDate)?.toLocaleDateString('en-GB') : ''
    }));

    // Create workbook and worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();

    // Set column widths
    const colWidths = [
      { wch: 15 }, // Month
      { wch: 15 }, // Bill ID
      { wch: 25 }, // Bill Name
      { wch: 15 }, // Bill Type
      { wch: 12 }, // Amount
      { wch: 10 }, // Currency
      { wch: 12 }, // Paid Status
      { wch: 15 }  // Paid Date
    ];
    ws['!cols'] = colWidths;

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Expenses');

    // Generate Excel file buffer
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    // Save the file
    this.saveExcelFile(excelBuffer, fileName);
  }

  /**
   * Export HTML table element to Excel (alternative method)
   */
  exportTableToExcel(element: ElementRef, fileName: string = 'expenses'): void {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }

  private saveExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(data, `${fileName}.xlsx`);
  }

  isMonthSelected(monthValue: any, year:any, type:any): boolean {
    // return this.selectedMonths[type]?.includes(year + '-' + monthValue) ||
    return this.selectedMonths[type]?.includes(monthValue) ||
           ( monthValue === 'All');
  }

  applyMonthSelection(type:any) {
    // this.toggleDatesDropdown(type);
    this.loader = true;
    this.currentPage = 1;
    if (this.selectedMonths[type].length === 0) {
      this[type] = null;
    } else {
      this[type] = this.selectedMonths[type]
        .filter(m => m !== 'All')
        .map(month => month + '-' +this.selectedDatesYear[type]);
    }
    this.getExpense();
  }

  // expenses: any[] = [
  //   { title: 'AWS', price: 2000.26, currency: 'USD', billUrl: 'assets/bill.jpg', type: 'Recurring', paid: 'UNPAID' },
  //   { title: 'Marketing', price: '', currency: '', billUrl: '', type: '', paid: '' },
  //   { title: 'Utilities', price: 7346.10, currency: 'AED', billUrl: 'assets/bill.jpg', type: 'Recurring', paid: 'UNPAID' },
  //   { title: 'Salaries', price: 2000.26, currency: 'USD', billUrl: 'assets/bill.jpg', type: 'Recurring', paid: 'UNPAID' },
  //   { title: 'Rent', price: 0, currency: '', billUrl: 'assets/bill.jpg', type: 'Recurring', paid: 'UNPAID' },
  //   {
  //     title: 'Extras',
  //     price: 7346.10,
  //     currency: 'AED',
  //     billUrl: 'assets/bill.jpg',
  //     type: 'Recurring',
  //     paid: 'UNPAID',
  //     extras: [
  //       { label: 'FLIGHTS', amount: 7346.10 },
  //       { label: 'SYSTEM REPAIR', amount: 7346.10 }
  //     ]
  //   }
  // ];

  openModal() {
    // this.updateFormMonthYear();
    // if(this.allMonthlyexpenses?.length > 0) this.processApiData()
      // else this.addExpense()
    if(this.editExpense) {
      this.expenses.clear();
      this.expenses.push(this.createExpense(this.editingExpense.billName, this.editingExpense.amount, this.editingExpense.currency, this.editingExpense.paymentStatus, this.editingExpense.description, this.editingExpense.type, this.editingExpense.dueDate, this.editingExpense.generationMonth, this.editingExpense.bill));
    } else {
      if(this.expenses.length == 0) this.addExpense();
    }
    setTimeout(() => {
      this.modalRef = this.modalService.show(this.generateBillModal, {
        class: 'modal-lg modal-dialog-centered',
        focus: false ,
        backdrop: 'static',
        keyboard: false
      })
    }, 500);
  }

  save(category: any) {
    console.log('Saving', category);
let obj

if(category === 'EXTRAS') {
      if(this.extrasForm.invalid) {
        this.extrasForm.markAllAsTouched();
        return;
      }
      obj = this.extrasForm.value.expenses;
      obj.forEach((expense: any) => {
        if(expense.billUpload) expense['bill'] = expense['bill']?.split(',')[1];
        expense.billUpload = undefined
      })
    } else {
  obj = [{
    "id": this.editingExpense.categories[category].id,
    "type": this.editingExpense.categories[category].type,
      "amount": +this.editingExpense.categories[category].amount,
      "paymentStatus": this.editingExpense.categories[category].paymentStatus,
       "dueDate": this.editingExpense.categories[category].dueDate,
      "currency": this.editingExpense.categories[category].currency,
      "bill": this.editingExpense.categories[category].bill,
      "description": this.editingExpense.categories[category].description,
  }]
  if(this.editingExpense.categories[category].billUpload) obj[0].bill = this.editingExpense.categories[category].bill?.split(',')[1]; // Extract base64 string from the file input

}

    this.apiService.updateExpense(obj).subscribe((response: any) => {
      console.log('Response from API:', response);
      if (response.status) {
        this.getExpense();
        this.editExpense = false;
        this.toastService.showSuccess('Expense updated successfully!');
        this.extrasForm.reset();
        this.extras.clear();
      }}, error => {
        this.toastService.showError('Failed to Update expense. Please try again.');
      });
    this
  }

  removeExtra(index: number) {
    this.apiService.deleteExpense([this.editingExpense.categories.Extras.extrasBreakDown[index].id]).subscribe((response: any) => {
      this.extras.removeAt(index);
    })
  }

  onlyNumbers(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    // Allow: backspace, delete, tab, escape, enter
    // Only allow numbers
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  addExtra() {
    let extra = [{
      category: 'Extras',
      amount: 0.01,
      currency: 'AED',
      // paymentStatus: 'UNPAID',
        type: 'ONE_OFF',
      description: '',
      // dueDate: '',
      // bill: null,
      month: this.editingExpense.month,
      year: this.editingExpense?.year
    }]
    this,this.apiService.createExpense(extra).subscribe((response: any) => {
      console.log('Response from API:', response);
      if (response.status) {
        this.extras.push(this.createExtraExpense(response.data[0]));
      }
    })
    // this.extras.push(this.createExtraExpense({ category: 'Extras', amount: 0.01, currency: 'AED', paymentStatus: 'UNPAID', type: 'RECURRING', description: '', dueDate: '' }));
  }

  // Track dropdown open/close states
dropdownOpen: { [key: string]: boolean } = {};

toggleDropdown(index: number, controlName: string) {
  const key = `${controlName}${index}`;
  this.dropdownOpen[key] = !this.dropdownOpen[key];
}

onMenuToggled(isCollapsed: boolean) {
  this.menuCollapsed.set(isCollapsed);
}

openEditExpense(expense,index) {
  this.editingExpense = expense;
  // setTimeout(() => {this.editExpense = true}, 500 )
  this.editExpense = true;
  this.openModal()
  this.extrasForm.reset();
  this.extras.clear();
  // while (this.extras.length !== 0) {
  //   this.extras.removeAt(0);
  // }
  // this.editingExpense.categories.Extras.extrasBreakDown.forEach((extra: any) => {
  //   this.extras.push(this.createExtraExpense(extra))
  // });
}


  // Add this helper method to safely access form control
getBillControl(expenseIndex: number) {
  return this.billForm.get(['expenses', expenseIndex, 'bill']) as FormControl;
}

getBillEditControl(expenseIndex: number) {
  return this.extras.get([ expenseIndex, 'bill']) as FormControl;
}

// Add this method to trigger file input
triggerFileInput(index: any,edit?: boolean) {
  document.getElementById('fileInput' + index)?.click();
}

// Fixed function name
onFileSelected(event: Event, expenseIndex: any,edit?: boolean) {
  const input = event.target as HTMLInputElement;

  if (!input.files || input.files.length === 0) return;

  const file = input.files[0];
  const reader = new FileReader();

 if(!edit) {
  reader.onload = () => {
    this.getBillControl(expenseIndex).setValue(reader.result as string);

    // Clear the input to allow reselecting same file
    input.value = '';
  };
  this.billForm.controls['expenses']['controls'][expenseIndex].controls['billUpload'].setValue(true)
 } else {
  reader.onload = () => {
    // this.getBillControl(expenseIndex).setValue(reader.result as string);
    this.editingExpense.categories[expenseIndex].bill = reader.result as string;

    // Clear the input to allow reselecting same file
    input.value = '';
  };
  this.editingExpense.categories[expenseIndex]['billUpload'] = true;

 }

  reader.onerror = (error) => {
    console.error('File reading error:', error);
    input.value = '';  // Reset on error
  };

  reader.readAsDataURL(file);
}

extrasFile(event: Event, expenseIndex: any,edit?: boolean) {
  const input = event.target as HTMLInputElement;

  if (!input.files || input.files.length === 0) return;

  const file = input.files[0];
  const reader = new FileReader();

 if(!edit) {
  reader.onload = () => {
    this.getBillEditControl(expenseIndex).setValue(reader.result as string);

    // Clear the input to allow reselecting same file
    input.value = '';
  };
  this.extrasForm.controls['expenses']['controls'][expenseIndex].controls['billUpload'].setValue(true)
 }

  reader.onerror = (error) => {
    console.error('File reading error:', error);
    input.value = '';  // Reset on error
  };

  reader.readAsDataURL(file);
}



submitData() {
  if(this.editExpense) {
    let obj = this.billForm.value.expenses[0];
    obj['id'] = this.editingExpense.id
    this.apiService.updateExpense(obj).subscribe((response: any) => {
      console.log('Response from API:', response);
      if (response.status) {
        this.getExpense();
        this.toastService.showSuccess('Expense updated successfully!');
        this.dismiss()
         // Clear the FormArray
      }
    }, error => {
      this.toastService.showError('Failed to Update expense. Please try again.');
    });
  } else {
    if (this.billForm.invalid) {
      this.billForm.markAllAsTouched();
      return;
    }

    let obj = this.billForm.value.expenses[0];
    const monthIndex = this.months.indexOf(obj.month.toUpperCase());
    const monthNum = (monthIndex + 1).toString().padStart(2, '0');
     obj.generationMonth =   `${obj.year}-${monthNum}`
    // obj['bill'] = obj['bill'].split(',')[1]; // Extract base64 string from the file input
    // obj.forEach((expense: any) => {
      if(obj.billUpload) obj['bill'] = obj['bill']?.split(',')[1];
      obj.billUpload = undefined
    // })
    this.apiService.createExpense(obj).subscribe((response: any) => {
       // Refresh the expenses list after submission
      console.log('Response from API:', response);
      if (response.status) {
        // this.getExpense();
        this.toastService.showSuccess('Expense added successfully!');
        this.dismiss()
      this.getExpense();
      }
    }, error => {
      this.toastService.showError('Failed to add expense. Please try again.');
    });
    console.log('Form Submitted', this.billForm.value);
  }
}

dismiss() {
  this.modalRef?.hide();
  this.editExpense = false
  this.billForm.reset();
  this.expenses.clear();
  // this.getExpense()
}

  // createExpense(): FormGroup {
  //   return this.fb.group({
  //     month: ['AUG', Validators.required],
  //     year:[2025],
  //     paymentStatus: ['UNPAID'],
  //     category: ['AWS', Validators.required],
  //     type: ['RECURRING', Validators.required],
  //     amount: ['0', [Validators.required, Validators.min(1)]],
  //     currency: ['AED', Validators.required],
  //     bill: [null], // No validation
  //     description: ['', Validators.required],
  //     dueDate: ['', Validators.required]
  //   });
  // }

  private getCurrentMonthYear(): { month: string, year: number } {
    const monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    const now = new Date();
    return {
      month: monthNames[now.getMonth()],
      year: now.getFullYear() // Format as YYYY-MM
    };
  }

  private getNextMonthYear(): { month: string, year: number } {
    const monthNames = this.months;

    // Fallback to current month/year if no month is selected
    if (!(this.allMonthlyexpenses?.length > 0) ) {
      return this.getCurrentMonthYear();
    }

    const currentMonthIndex = monthNames.indexOf(this.allMonthlyexpenses[0]?.month);
    // Fallback if invalid month string is provided
    if (currentMonthIndex === -1) {
      return this.getCurrentMonthYear();
    }

    let nextMonthIndex = currentMonthIndex + 1;
    let nextYear = new Date().getFullYear();

    if (nextMonthIndex > 11) {
      nextMonthIndex = 0;
      nextYear++;
    }

    return {
      month: monthNames[nextMonthIndex],
      year: nextYear
    };
  }

  // private updateFormMonthYear() {
  //   const { month, year } = this.getNextMonthYear();
  //   this.expenses.controls.forEach(control => {
  //     control.patchValue({
  //       month: month,
  //       year: year
  //     });
  //   });
  // }

  createExpense(
    category: string,
    amount: number,
    currency: string,
    paymentStatus: string,
    description: string = '',
    type:string,
    dueDate:string,
    generationMonth:string = '',
    bill:any
  ): FormGroup {
    const { month, year } = this.getCurrentMonthYear();

    return this.fb.group({
      month: [this.editExpense ? this.editingExpense.month : month, Validators.required],
      year: [this.editExpense ? this.editingExpense.year : year],
      paymentStatus: [paymentStatus || 'UNPAID'],
      billName: [category, Validators.required],
      type: [type, Validators.required],
      period: [this.editExpense ? this.editingExpense.period : 6],
      amount: [amount || 0, [Validators.required, Validators.min(1)]],
      currency: [currency || 'AED', Validators.required],
      bill: [bill],
      billUpload: [false],
      generationMonth: [generationMonth],
      description: [description],
      dueDate: [dueDate]
    });
  }

  createExtraExpense(
    extra
  ): FormGroup {

    return this.fb.group({
      month: [this.editingExpense.month],
      year: [this.editingExpense?.year || 2025],
      paymentStatus: [extra.paymentStatus || 'UNPAID'],
      category: ['Extras'],
      type: [extra.type],
      amount: [extra.amount || 0, [Validators.required, Validators.min(1)]],
      currency: [extra.currency || 'AED', Validators.required],
      bill: [extra.bill ],
      billUpload: [false],
      description: [extra.description, Validators.required],
      dueDate: [extra.dueDate],
      id: [extra.id || null]
    });
  }

  // private calculateDefaultDueDate(month: string, year: number): string {
  //   const monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  //   const monthIndex = monthNames.indexOf(month);
  //   const date = new Date(year, monthIndex + 1, 0); // Last day of the month
  //   return date.toISOString().split('T')[0];
  // }

  processApiData() {
    while (this.expenses.length !== 0) {
      this.expenses.removeAt(0);
    }

    const categories = this.allMonthlyexpenses[0].categories;
    Object.keys(categories).forEach(key => {
      if (key !== 'Extras') {
        const category = categories[key];
        if (category.amount > 0) {
          this.expenses.push(this.createExpense(
            key,
            category.amount,
            category.currency,
            category.paymentStatus,
            category.description || '',
            category.type || 'RECURRING',
            category.dueDate,
            category.generationMonth,
            category.bill || null
          ));
        }
      }
    });

    if (categories.Extras && categories.Extras.extrasBreakDown) {
      categories.Extras.extrasBreakDown.forEach((extra: any) => {
        if((extra.type !== 'ONE_OFF' && this.checkThreeMonthsPassed(extra.generationMonth, extra.type)) || extra.type === 'RECURRING') {
          this.expenses.push(this.createExpense(
            'Extras',
            extra.amount,
            extra.currency,
            extra.paymentStatus,
            extra.description || '',
            extra.type || 'RECURRING',
            extra.dueDate,
            extra.generationMonth,
            extra.bill || null
          ));
        }
      });
    }
  }

  checkThreeMonthsPassed(generationMonth: string, type: string): boolean {
    // Only proceed if type is THREE_MONTH
    if (type !== 'THREE_MONTH' && type !== 'SIX_MONTH') {
      return false;
    }

    // const currentMonthIndex = new Date().getMonth(); // 0-11 (Jan-Dec)
    const { month, year } = this.getNextMonthYear();
    const currentMonthIndex = this.months.indexOf(month.toUpperCase()); // 0-11 (Jan-Dec)
    const currentMonth = this.months[currentMonthIndex];

    const generationMonthIndex = this.months.indexOf(generationMonth.toUpperCase());

    // If generation month not found, return false
    if (generationMonthIndex === -1) {
      return false;
    }

    // Calculate the difference in months
    let monthDifference = currentMonthIndex - generationMonthIndex;

    // Handle year wrap-around (e.g., generationMonth: NOV, currentMonth: JAN)
    if (monthDifference < 0) {
      monthDifference += 12;
    }

    // Return true if current month is within 3 months after generation month
    // (including generation month itself + next 2 months)
    let compareMonths = type == 'THREE_MONTH' ? 2 : 5
    return monthDifference <= compareMonths;
  }

  getExpense() {
    this.loader = true
    let obj = {
      page: this.currentPage - 1,
      search: this.searchText,
      all: false,
      status: this.selectedPaymentStatus,
      month: this.selectedMonth,
      paidMonth: this.selectedPaidMonth,
    }
    if(this.searchText || this.selectedPaymentStatus || this.selectedMonth || this.selectedPaidMonth) this.isFilterApplied = true
    this.apiService.getExpenses(obj).subscribe((response: any) => {
      if(response.status) {
        this.allMonthlyexpenses = response.data.expenses || [];
        this.expenseData = response.data
        this.loader = false
      } else {
        this.toastService.showError(response.message || 'Failed to fetch expenses. Please try again.');
        this.loader = false
        if(response.message.includes('expired')) {
          sessionStorage.removeItem('accessToken');
          this.openOtpModal()
        }
        if (response.message == 'JWT token is missing or invalid. Please login.') {
          this.authService.logout();
          localStorage.clear();
          sessionStorage.clear();
          this.router.navigate(['/']);
        }
      }
    }, error => {
      this.toastService.showError(error.error.message || 'Failed to fetch expenses. Please try again.')
      this.loader = false
      if(error.error.message.includes('expired')) {
        sessionStorage.removeItem('accessToken');
        this.openOtpModal()
      }
      if (error.error.message == 'JWT token is missing or invalid. Please login.') {
        this.authService.logout();
        localStorage.clear();
        sessionStorage.clear();
        this.router.navigate(['/']);
      }
    })
  }



  isInvalid(index: number, controlName: string): boolean {
    const control = (this.expenses.at(index) as FormGroup).get(controlName);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  getAvailableCategories(index: number): string[] {
    // Function to normalise values for comparison
    const normalise = (val: string | null | undefined) =>
      (val ?? '').trim().toLowerCase();

    // All selected categories except the current row and "extras"
    const selected = this.expenses.controls
      .map((ctrl, i) =>
        i !== index ? normalise(ctrl.get('billName')?.value) : null
      )
      .filter(
        (cat): cat is string => !!cat && cat !== 'extras'
      );

    // Filter categories: always allow "extras", exclude others if already chosen
    return this.categories.filter(
      category =>
        normalise(category) === 'extras' ||
        !selected.includes(normalise(category))
    );
  }



  addExpense() {
    // if(this.allMonthlyexpenses?.length > 0) this.expenses.push(this.createExpense('Extras', 0, 'AED', 'UNPAID', '','RECURRING','','',''));
    this.expenses.push(this.createExpense('AWS', 0, 'AED', 'UNPAID', '','RECURRING','','',''));
  }

  removeExpense(id: any) {
    this.apiService.deleteExpense([id]).subscribe((response: any) => {
      // this.extras.removeAt(index);
      if(response.status) {
        this.getExpense();
        this.toastService.showSuccess('Expense deleted successfully!');
      }
      else {
        this.toastService.showError('Failed to delete expense. Please try again.');
      }
    })
  }

  trackByCategory(index: number, category: string): string {
    return category;
  }

  ngOnDestroy() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }
}

